module.exports = __webpack_public_path__ + "static/media/background.5bb229c3.mp4";